export default function TabHeader({ title, note, children }) {
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="font-display text-4xl font-extralight tracking-tight text-ink">{title}</h1>
        {note && <p className="mt-2 max-w-2xl font-body text-sm leading-relaxed text-stone">{note}</p>}
      </div>
      {children}
    </div>
  );
}
